import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CoinsPlus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CoinsPlus } from '@sravni/design-system-icons'
 *
 * <CoinsPlus />
 * ```
 */
var CoinsPlus = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CoinsPlus", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.618 8.065a5.527 5.527 0 1 1-7.816 7.816 5.527 5.527 0 0 1 7.816-7.816M12.712 10.416v3.117M14.27 11.975h-3.117", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.855 11.934a5.525 5.525 0 1 1 7.815-7.815", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CoinsPlus };
//# sourceMappingURL=CoinsPlus.js.map
